export const ITEM_LIST_REQUEST = 'ITEM_LIST_REQUEST'
export const ITEM_LIST_SUCCESS = 'ITEM_LIST_SUCCESS'
export const ITEM_LIST_FAIL = 'ITEM_LIST_FAIL'
export const ITEM_LIST_RESET = 'ITEM_LIST_RESET'

export const ITEM_ADD_REQUEST = 'ITEM_ADD_REQUEST'
export const ITEM_ADD_SUCCESS = 'ITEM_ADD_SUCCESS'
export const ITEM_ADD_FAIL = 'ITEM_ADD_FAIL'

export const ITEM_DELETE_REQUEST = 'ITEM_DELETE_REQUEST'
export const ITEM_DELETE_SUCCESS = 'ITEM_DELETE_SUCCESS'
export const ITEM_DELETE_FAIL = 'ITEM_DELETE_FAIL'

export const ITEM_ALL_REQUEST = 'ITEM_ALL_REQUEST'
export const ITEM_ALL_SUCCESS = 'ITEM_ALL_SUCCESS'
export const ITEM_ALL_FAIL = 'ITEM_ALL_FAIL'
